import React from 'react';
import { useNavigate } from 'react-router-dom';
import { parlorScreen } from '../../designs';
import OnboardingLayout from './OnboardingLayout';
import { useOnboardingData } from './useOnboardingData';
import Input from '../../components/ui/Input';
import PlacesAutocomplete from '../../components/ui/PlacesAutocomplete';
import DateSpinner from '../../components/ui/DateSpinner';

const d = parlorScreen.tokens;
const fs = parlorScreen.typography.fontSize;

function getDayPills(startDate: string, endDate: string): string[] {
  if (!startDate || !endDate) return [];
  const start = new Date(startDate + 'T00:00:00');
  const end = new Date(endDate + 'T00:00:00');
  if (end <= start) return [];
  const days: string[] = [];
  const current = new Date(start);
  while (current <= end) {
    days.push(current.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase());
    current.setDate(current.getDate() + 1);
  }
  return days;
}

export default function OnboardingStep1Dates() {
  const navigate = useNavigate();
  const { data, setData } = useOnboardingData();

  const dayPills = getDayPills(data.startDate, data.endDate);

  return (
    <OnboardingLayout
      step={1}
      headline="What are we celebrating?"
      buttonLabel="Next"
      onSubmit={() => navigate('/new-trip/crew')}
      onSkip={() => navigate('/new-trip/crew')}
    >
      <Input label="Occasion" type="text" value={data.occasion}
        onChange={(e) => setData({ occasion: e.target.value })} />

      <Input label="Trip Name" type="text" value={data.tripName}
        onChange={(e) => setData({ tripName: e.target.value })} />

      <PlacesAutocomplete label="Destination City" value={data.destination}
        onChange={(val) => setData({ destination: val })} citiesOnly />

      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
        <DateSpinner label="Start Date" value={data.startDate}
          onChange={(v) => setData({ startDate: v })} />
        <DateSpinner label="End Date" value={data.endDate}
          onChange={(v) => setData({ endDate: v })} min={data.startDate} />
      </div>

      {/* Day pills */}
      {dayPills.length > 0 && (
        <div style={{
          display: 'flex', justifyContent: 'center', gap: '6px',
          flexWrap: 'wrap', marginTop: '8px',
        }}>
          {dayPills.map((day, i) => (
            <span key={i} style={{
              fontFamily: "'Raleway', sans-serif", fontSize: fs.metaLabel, fontWeight: 600,
              letterSpacing: '1px', padding: '4px 12px',
              border: `1px solid rgba(200,146,58,0.20)`, borderRadius: '2px',
              color: d.textSecondary,
            }}>
              {day}
            </span>
          ))}
        </div>
      )}
    </OnboardingLayout>
  );
}
